<template>
  <div class="carousel" :class="{ 'half-height': isTargetPage }">
    <!-- Banner 区域：目标页面文字缩小，首页原尺寸 -->
    <div class="banner-container">
      <div class="banner-bg"></div>
      <div class="banner-content" :class="{ 'small-text': isTargetPage }">
        <h2 class="banner-title">最稳定、高可用、高转化的特货独立站SaaS系统</h2>
        <p class="banner-desc">拒绝二次收费，拒绝按功能收费，拒绝交易抽佣! <br>
          Shop910系统内置 AB跳转轮询、斗篷Cloak、信用卡收款等功能全部免费使用，所有交易免抽佣!
        </p>
      </div>
    </div>

    <!-- 滚动图片区域：首页双行，目标页面单行+图片原尺寸 -->
    <div class="scroll-images-wrapper" :class="{ 'single-scroll': isTargetPage }">
      <!-- 上一行：始终显示 -->
      <div class="scroll-row scroll-left">
        <div class="scroll-content">
          <div class="scroll-img-item"><img src="/shop/scroll-1.jpg" alt="滚动图1" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-2.jpg" alt="滚动图2" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-3.jpg" alt="滚动图3" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-4.jpg" alt="滚动图4" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-5.jpg" alt="滚动图5" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-6.jpg" alt="滚动图6" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-7.jpg" alt="滚动图7" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-8.jpg" alt="滚动图8" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-1.jpg" alt="滚动图1-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-2.jpg" alt="滚动图2-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-3.jpg" alt="滚动图3-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-4.jpg" alt="滚动图4-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-5.jpg" alt="滚动图5-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-6.jpg" alt="滚动图6-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-7.jpg" alt="滚动图7-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-8.jpg" alt="滚动图8-复" /></div>
        </div>
      </div>

      <!-- 下一行：首页显示，目标页面隐藏 -->
      <div class="scroll-row scroll-right" v-if="!isTargetPage">
        <div class="scroll-content">
          <div class="scroll-img-item"><img src="/shop/scroll-9.jpg" alt="滚动图9" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-10.jpg" alt="滚动图10" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-11.jpg" alt="滚动图11" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-12.jpg" alt="滚动图12" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-13.jpg" alt="滚动图13" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-14.jpg" alt="滚动图14" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-15.jpg" alt="滚动图15" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-16.jpg" alt="滚动图16" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-9.jpg" alt="滚动图9-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-10.jpg" alt="滚动图10-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-11.jpg" alt="滚动图11-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-12.jpg" alt="滚动图12-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-13.jpg" alt="滚动图13-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-14.jpg" alt="滚动图14-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-15.jpg" alt="滚动图15-复" /></div>
          <div class="scroll-img-item"><img src="/shop/scroll-16.jpg" alt="滚动图16-复" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoplineBanner',
  // 接收从 App.vue 传递的路由状态（判断是否为目标页面）
  props: {
    isTargetPage: {
      type: Boolean,
      default: false // 默认首页（非目标页面）
    },
    slides: { type: Array, default: () => [] },
    interval: { type: Number, default: 5000 }
  },
  // 原有逻辑不变
  data() { return { currentIndex: 0, timer: null }; },
  mounted() { this.startAutoPlay(); },
  methods: {
    startAutoPlay() { this.timer = setInterval(() => this.nextSlide(), this.interval); },
    stopAutoPlay() { if (this.timer) clearInterval(this.timer); },
    nextSlide() { this.currentIndex = (this.currentIndex + 1) % this.slides.length; },
    prevSlide() { this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length; },
    goToSlide(index) { this.currentIndex = index; }
  },
  beforeDestroy() { this.stopAutoPlay(); }
}
</script>

<style scoped>
/* 首页默认样式：背景高度1000px，双行滚动 */
.carousel {
  position: relative;
  width: calc(100% - 60px);
  margin: 30px 30px;
  height: 1000px; /* 首页原高度 */
  overflow: hidden;
  border-radius: 30px 30px 30px 0;
  z-index: 1;
}

/* 目标页面专属：背景高度减半（1000px → 500px） */
.half-height {
  height: 500px !important;
}

/* Banner 区域基础样式 */
.banner-container { position: relative; width: 100%; height: 100%; }
.banner-bg {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(37, 41, 97, 1), rgba(112, 129, 255, 1));
}
.banner-content {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  z-index: 3;
  padding: 0 20px;
  width: 100%;
}
.banner-title { font-size: 48px; font-weight: 700; margin-bottom: 10px; line-height: 1.2; }
.banner-desc { font-size: 18px; margin-bottom: 30px; opacity: 0.9; }

/* 目标页面：文字缩小 */
.small-text .banner-title { font-size: 24px !important; margin-bottom: 8px !important; }
.small-text .banner-desc { font-size: 14px !important; line-height: 1.5 !important; }

/* 滚动区域：首页双行（高度550px），目标页面单行（高度275px） */
.scroll-images-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 500px; /* 首页双行高度 */
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 10px; /* 首页双行间距 */
  z-index: 2;
  background: transparent;
}

/* 目标页面：滚动区域单行高度 */
.single-scroll {
  height: 275px !important;
  gap: 0 !important; /* 取消行间距 */
}

/* 滚动行样式：图片保持原尺寸 */
.scroll-row {
  width: 100%;
  height: calc(50% - 5px); /* 首页双行平分高度 */
  overflow: hidden;
  position: relative;
}

/* 目标页面：滚动行占满单行高度 */
.single-scroll .scroll-row {
  height: 100% !important;
  max-height: none !important; /* 取消最大高度限制 */
}

.scroll-content {
  display: flex;
  flex-wrap: nowrap;
  width: auto;
  height: 100%;
  align-items: center;
  
}
.scroll-img-item {
  width: auto;
  height: 100%;
  margin: 0 10px;
  box-sizing: border-box;
}

/* 核心：图片保持原尺寸，不缩小、不拉伸 */
.scroll-img-item img {
  width: auto;
  height: 100%;
  max-height: 180px !important; /* 限制最大高度，防止溢出 */
  max-width: 250px !important; /* 限制最大宽度，避免图片过宽 */
  object-fit: contain; /* 保持原比例完整显示 */
  border-radius: 8px;
}

/* 滚动动画不变 */
@keyframes scrollLeft { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
@keyframes scrollRight { 0% { transform: translateX(-50%); } 100% { transform: translateX(0); } }
.scroll-left .scroll-content { animation: scrollLeft 30s linear infinite; }
.scroll-right .scroll-content { animation: scrollRight 30s linear infinite; }

/* 响应式适配：首页和目标页面分别适配 */
@media (max-width: 768px) {
  /* 首页移动端 */
  .carousel { height: 400px; }
  .scroll-images-wrapper { height: 220px; gap: 8px; }
  /* 目标页面移动端 */
  .half-height { height: 200px !important; }
  .single-scroll { height: 110px !important; }
  .scroll-img-item { margin: 0 5px; }
}
@media (max-width: 576px) {
  /* 首页移动端：居中显示+避开fixed导航栏 */
  .carousel {
    height: 300px !important;
    width: calc(100% - 30px) !important; /* 调整宽度边距，更对称 */
    margin: 70px auto 0 !important; /* 顶部70px避开导航栏，左右auto居中 */
    border-radius: 30px;
  }
  /* 目标页面移动端：同样居中+避导航栏 */
  .half-height {
    height: 250px !important;
    margin: 70px auto 0 !important;
  }
  .scroll-images-wrapper {
    height: 150px;
    gap: 6px;
    padding: 10px 0; /* 减少上下内边距，避免溢出 */
  }
  /* 目标页面移动端滚动区域 */
  .single-scroll {
    height: 120px !important;
    bottom: 20px !important;
  }
  .scroll-img-item {
    margin: 0 3px;
  }
  /* 移动端文字默认适配 */
  .banner-title {
    font-size: 24px;
  }
  .banner-desc {
    font-size: 9px;
  }
  /* 目标页面移动端文字 */
  .small-text .banner-title {
    font-size: 16px !important;
  }
  .small-text .banner-desc {
    font-size: 10px !important;
  }
}
/* 按钮样式（如需显示可取消注释） */
.btn-shop {
  background: #fff;
  color: #232650;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: transform 0.3s;
}
.btn-learn {
  background: transparent;
  color: #fff;
  border: 2px solid #fff;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.3s;
}
.btn-shop:hover { transform: translateY(-3px); }
.btn-learn:hover { background: rgba(255, 255, 255, 0.2); }
</style>